import ExamTable from '@/components/organisms/Table/ExamTable';

import { Button,Input, Tabs, TabItem } from 'components/atoms/index';
import { useLocation, useNavigate } from 'react-router-dom';

// 시험 리스트
export default function StudentExamList() {


  return (    
    <main className='flex flex-1 justify-center w-full bg-white lg:my-10 card md:py-5 md:bg-transparent'>
        <div className='flex flex-col w-full'>
            <h1 className='px-5 pb-3 heading1'>온라인 시험</h1>
                <section className='flex flex-1 px-5 w-full lg:px-0'>
                    <ExamTable />
                </section>
            </div>
    </main>
  )
}